import { Injectable } from '@angular/core';

@Injectable()
export class ConstantsService {

  public apiURL;
  public versionNumber;

  constructor() {
    // Prod ProfinBox
    //this.apiURL = 'https://api.profinbox.com/api';
    //Prod
    this.apiURL = 'https://api.klabe.app/api';
    //QA
    // this.apiURL = 'https://qaprofinmexapi.inflexionsoftware.com/api';
    //STG
    //this.apiURL = "http://profinmex-api-temp.demosandbox.net/api"
    // Local
    //this.apiURL = 'http://127.0.0.1/profinmex-api/public/api';
    this.versionNumber = '2.0.7';
  }

}



// WEBPACK FOOTER //
// ./src/app/services/constants.service.ts